<template>
  <div id="app" v-cloak>
    <Loading :loading="loading" v-if="loading" />
    <router-view v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Loading from './components/uikit/LoadingMask';
export default {
  name: 'App',
  components: { Loading },
  computed: {
    ...mapState({
      loading: state => state.loading,
    }),
  },
};
</script>
